import request from '@/utils/request';
import { errorMsg } from '@/utils/message';
import { errorNotify } from '@/utils/errorNotification';

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.tenant - テナントのID
 * @return {Promise<string>} テナントの名前
 */
export async function getTenantName(data) {
  let tenantName = '';
  try {
    const tenant = await request({
      url: '/tenantmasters/methods/tenantmaster',
      method: 'get',
    });
    tenantName = tenant.tenantName;
  } catch {
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return tenantName;
}
